import React from 'react';
import { Container, Row } from 'react-bootstrap';

import { teamApi } from '../../api';
import { hasSuperuserAccess } from '../../utils';
import { SUPERUSER_LEVEL } from '../../constants';

import PageTitle from '../../components/common/PageTitle';
import DisabledOverlay from '../../components/common/DisabledOverlay';
import RequestsReturnList from '../../components/common/transactions/RequestsReturnList';

function RequestsReturn({ t, user }) {
  return (
    <Container className="main-content-container p-3 p-md-5 d-flex flex-column flex-grow-1 d-flex flex-column flex-grow-1">
      <Row className="g-0 page-header mb-3 mb-md-5">
        <PageTitle title={t('admin.requestsReturn.title')} backBtn />
      </Row>

      {hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS]) ? (
        <RequestsReturnList
          customer={false}
          filterName={`team_${user.currentTeam.id}_requests_return_admin`}
          hasPermission={hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS])}
          fetchData={teamApi.fetchRequestsReturn}
          fetchOptions={{
            team: user.currentTeam.id,
          }}
          generateRowUrl={(row) => `/admin/request-return/${row.uuid || row.original.uuid}/detail`}
        />
      ) : (
        <div className="position-relative">
          <DisabledOverlay />
        </div>
      )}
    </Container>
  );
}

export default RequestsReturn;
